<template>
    <div class="mt-1">
        <b-form-select
            v-model="option"
            :options="filterOptions.accountingFirmCompanies"
            :disabled="!viewAllClients"
            size="sm"
            :class="selectClass"
            @change="setFilter"
        />
    </div>
</template>

<script>
import {mapState} from 'vuex'
import DataUpdater from '../../../dashboard/mixins/DataUpdater.vue'

export default {
    name: 'AccountingFirmCompanySelect',

    mixins: [DataUpdater],

    data() {
        return {
            option: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            filterOptions: (state) => state.data.options,
            viewAllClients: (state) => state.reportingVM.viewAllClients,
        }),

        selectClass() {
            return this.option === 0 ? 'bg-white' : 'selected-filter'
        },
    },

    created() {
        this.option = this.filters.accountingFirmCompany
    },

    methods: {
        async setFilter() {
            await this.$store.dispatch(
                'reportingVM/setAccountingFirmCompanyFilter',
                this.option
            )
            this.$emit('company-has-changed')
            this.updateData()
            await this.$store.dispatch('reportingVM/refreshCounters')
        },
    },
}
</script>

<style scoped></style>
